import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import TextField from "@mui/material/TextField";
import { Preloader } from "../common/index.js";
import ReactInputMask from "../../ReactInputMask/index.js";
import SuggestedInput_styles from "./SuggestedInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TextFieldMasked_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TextFieldMasked_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const TextFieldMasked = (t0)=>{
    const $ = c(52);
    let InputLabelProps;
    let InputProps;
    let error;
    let helperText;
    let id;
    let inputProps;
    let loading;
    let mask;
    let name;
    let onChange;
    let rest;
    if ($[0] !== t0) {
        ({ id, mask, name, error, helperText, loading, onChange, inputProps, InputProps, InputLabelProps } = t0), rest = _object_without_properties(t0, [
            "id",
            "mask",
            "name",
            "error",
            "helperText",
            "loading",
            "onChange",
            "inputProps",
            "InputProps",
            "InputLabelProps"
        ]);
        $[0] = t0;
        $[1] = InputLabelProps;
        $[2] = InputProps;
        $[3] = error;
        $[4] = helperText;
        $[5] = id;
        $[6] = inputProps;
        $[7] = loading;
        $[8] = mask;
        $[9] = name;
        $[10] = onChange;
        $[11] = rest;
    } else {
        InputLabelProps = $[1];
        InputProps = $[2];
        error = $[3];
        helperText = $[4];
        id = $[5];
        inputProps = $[6];
        loading = $[7];
        mask = $[8];
        name = $[9];
        onChange = $[10];
        rest = $[11];
    }
    const { classes } = SuggestedInput_styles();
    let inputPropsRest;
    if ($[12] !== inputProps) {
        const { value } = inputProps, t1 = _object_without_properties(inputProps, [
            "value"
        ]);
        inputPropsRest = t1;
        $[12] = inputProps;
        $[13] = inputPropsRest;
    } else inputPropsRest = $[13];
    let t1;
    if ($[14] !== inputProps || $[15] !== onChange) {
        t1 = (e)=>{
            var _inputProps_onChange;
            onChange(e, e.target.value);
            null == (_inputProps_onChange = inputProps.onChange) || _inputProps_onChange.call(inputProps, e);
        };
        $[14] = inputProps;
        $[15] = onChange;
        $[16] = t1;
    } else t1 = $[16];
    const handleChange = t1;
    const t2 = null == inputProps ? void 0 : inputProps.onFocus;
    const t3 = null == inputProps ? void 0 : inputProps.onBlur;
    const t4 = null == inputProps ? void 0 : inputProps.onMouseDown;
    const t5 = null == inputProps ? void 0 : inputProps.onKeyDown;
    let t6;
    if ($[17] !== classes.inputRoot) {
        t6 = {
            root: classes.inputRoot
        };
        $[17] = classes.inputRoot;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== inputPropsRest) {
        t7 = _object_spread({}, inputPropsRest);
        $[19] = inputPropsRest;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== loading) {
        t8 = loading ? {
            endAdornment: /*#__PURE__*/ jsx(Preloader, {})
        } : {};
        $[21] = loading;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== InputProps || $[24] !== t8) {
        t9 = _object_spread({}, InputProps, t8);
        $[23] = InputProps;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    let t10;
    if ($[26] !== InputLabelProps) {
        t10 = _object_spread({}, InputLabelProps);
        $[26] = InputLabelProps;
        $[27] = t10;
    } else t10 = $[27];
    let t11;
    if ($[28] !== t10 || $[29] !== t7 || $[30] !== t9) {
        t11 = {
            htmlInput: t7,
            input: t9,
            inputLabel: t10
        };
        $[28] = t10;
        $[29] = t7;
        $[30] = t9;
        $[31] = t11;
    } else t11 = $[31];
    let t12;
    if ($[32] !== InputProps.ref || $[33] !== error || $[34] !== helperText || $[35] !== id || $[36] !== name || $[37] !== rest || $[38] !== t11 || $[39] !== t6) {
        t12 = /*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({}, rest), {
            id: id,
            inputRef: InputProps.ref,
            name: name,
            classes: t6,
            autoComplete: "off",
            variant: "outlined",
            fullWidth: true,
            error: error,
            helperText: helperText,
            placeholder: rest.placeholder,
            slotProps: t11
        }));
        $[32] = InputProps.ref;
        $[33] = error;
        $[34] = helperText;
        $[35] = id;
        $[36] = name;
        $[37] = rest;
        $[38] = t11;
        $[39] = t6;
        $[40] = t12;
    } else t12 = $[40];
    let t13;
    if ($[41] !== handleChange || $[42] !== inputProps.value || $[43] !== mask || $[44] !== name || $[45] !== rest.disabled || $[46] !== t12 || $[47] !== t2 || $[48] !== t3 || $[49] !== t4 || $[50] !== t5) {
        t13 = /*#__PURE__*/ jsx(ReactInputMask, {
            value: inputProps.value,
            onFocus: t2,
            onBlur: t3,
            onMouseDown: t4,
            onKeyDown: t5,
            mask: mask,
            name: name,
            onChange: handleChange,
            disabled: rest.disabled,
            children: t12
        });
        $[41] = handleChange;
        $[42] = inputProps.value;
        $[43] = mask;
        $[44] = name;
        $[45] = rest.disabled;
        $[46] = t12;
        $[47] = t2;
        $[48] = t3;
        $[49] = t4;
        $[50] = t5;
        $[51] = t13;
    } else t13 = $[51];
    return t13;
};
export { TextFieldMasked };
